"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gallerySMNumberOfElements = exports.gallerySMGap = exports.gallerySMBoxSize = exports.galleryNumberOfElements = exports.galleryMinItemWidth = exports.galleryMaxWidth = exports.galleryMaxItemWidth = exports.galleryMDNumberOfElements = exports.galleryMDMinItemWidth = exports.galleryMDMaxItemWidth = exports.galleryMDGap = exports.galleryMDBoxSize = exports.galleryGap = exports.galleryBoxSize = void 0;
const galleryMaxWidth = exports.galleryMaxWidth = 1290;

// Mobile
const galleryGap = exports.galleryGap = 3;
const galleryMaxItemWidth = exports.galleryMaxItemWidth = 270;
const galleryMinItemWidth = exports.galleryMinItemWidth = 157;
const galleryNumberOfElements = exports.galleryNumberOfElements = 2;
const galleryBoxSize = exports.galleryBoxSize = `calc((100vw - 29px) / ${galleryNumberOfElements})`;

// Small (600+)
const gallerySMGap = exports.gallerySMGap = 4;
const gallerySMNumberOfElements = exports.gallerySMNumberOfElements = 3;
const gallerySMBoxSize = exports.gallerySMBoxSize = `calc((100vw - 64px) / ${gallerySMNumberOfElements})`;

// Large and up (1200+)
const galleryMDGap = exports.galleryMDGap = 6;
const galleryMDMaxItemWidth = exports.galleryMDMaxItemWidth = 300;
const galleryMDMinItemWidth = exports.galleryMDMinItemWidth = 202;
const galleryMDNumberOfElements = exports.galleryMDNumberOfElements = 4;
const galleryMDBoxSize = exports.galleryMDBoxSize = `calc((100vw - 150px) / ${galleryMDNumberOfElements})`;
